exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media screen and (max-width: 767px) {\ntable[data-v-e15ee78e] {\n    border-collapse: collapse;\n    border-spacing: 0;\n    width: 100%;\n    max-width: 100%;\n    overflow-x: auto;\n    table-layout: fixed;\n}\ntr[data-v-e15ee78e] {\n    background-color: #eff8ff80;\n}\ntbody[data-v-e15ee78e] {\n    background-color: #f9faff;\n}\ntd[data-v-e15ee78e], th[data-v-e15ee78e] {\n    text-align: left;\n    word-break: break-word;\n    border: 1px solid rgba(52, 144, 220, 0.5);\n    width: 20%;\n    padding: 0.5em;\n}\na.cursor-pointer[data-v-e15ee78e] {\n    display: block;\n}\n}", ""]);

// exports
